var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-shared-tips-line-copy",class:{ 'c-shared-tips-line-copy--solo-credit': _vm.isSoloCredit }},[_c('div',{staticClass:"c-shared-tips-line-copy__inner"},[_c('icon',{attrs:{"icon":"credits"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }